'use client';

import { motion } from 'framer-motion';
import { LabItem, LabType } from '@/types/labs';
import ImageAdaptive from '@/components/ImageAdaptive';
import LabBadge from '@/components/features/lab/LabBadge';
import LabNumber from '@/components/features/lab/LabNumber';
import LabScoreCount from '@/components/features/lab/LabScoreCount';
import LabAvatar from '@/components/ui/avatar/LabAvatar';

export interface LabListUnitProps {
    data: LabItem;
}

export default function LabListUnit({ data }: LabListUnitProps) {
    return (
        <motion.div key={data?.lab_id} className="relative flex flex-col w-full cursor-pointer">
            <div className="relative w-full rounded-xl">
                <div className="relative w-full aspect-[50/13] rounded-t-xl">
                    <img
                        src={data?.lab_header_resource_url ?? '/images/lab/no-header.png'}
                        className="w-full h-full rounded-t-xl object-cover opacity-90"
                        alt="Lab Header"
                    />
                    <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 z-10">
                        <LabAvatar avatarUrl={data?.lab_avatar_resource_url} labId={data.lab_id} size={100} />
                    </div>
                </div>
                <div className="relative z-0 mt-14 px-2 pb-2">
                    <div className="flex justify-center mt-2">
                        <LabNumber labNumber={data.lab_id} />
                    </div>
                    <div className="flex flex-col text-center font-corp font-bold text-sm mt-2 line-clamp-2 leading-tight h-[50px] min-h-[50px]">
                        <div className="flex justify-center items-start w-full h-full text-color-base">
                            {data.lab_name}
                        </div>
                        <div className="flex justify-center">
                            <LabBadge labType={data.lab_type as LabType} baseWidth={32} />
                        </div>
                    </div>
                    <div className="mt-auto flex justify-between items-center">
                        <div className="flex justify-center items-center w-[50%]">
                            <ImageAdaptive
                                src="/images/common/count-member.svg"
                                baseWidth={50}
                                breakpoints={{ md: 50 }}
                            />
                            <div className="ml-2 font-corp font-bold text-sm text-color-base">
                                {data.lab_score?.member_count}
                            </div>
                        </div>
                        <div className="flex justify-center items-center w-[50%]">
                            <LabScoreCount count={Number(data.lab_score?.total_score)} />
                        </div>
                    </div>
                </div>
            </div>
        </motion.div>
    );
}
